import React from "react"
import { useIntl } from "react-intl"
import "./index.scss"

import { BREADCRUMB_OPTIONS } from "components/Configuration/constants"
import ContextualHeader, {
	createBreadcrumbsTranslated,
} from "components/Shared/ContextualHeader"
import { Card } from "@walmart-web/livingdesign-components"
import { ChangePasswordResult } from "./service"
import ChangePasswordError from "./ChangePasswordError"
import ChangePasswordForm from "./ChangePasswordForm"
import ChangePasswordSuccess from "./ChangePasswordSuccess"

const ChangePw: React.FC = () => {
	const intl = useIntl()
	const [changePasswordResult, setChangePasswordResult] = React.useState<
		ChangePasswordResult
	>()

	const getComponent = () => {
		return changePasswordResult ? (
			getResultCommponent()
		) : (
			<ChangePasswordForm setChangePasswordResult={setChangePasswordResult} />
		)
	}

	const resetForm = () => setChangePasswordResult(undefined)

	const getResultCommponent = () => {
		if (changePasswordResult === ChangePasswordResult.Success)
			return <ChangePasswordSuccess />
		return (
			<ChangePasswordError
				error={changePasswordResult as ChangePasswordResult}
				resetForm={resetForm}
			/>
		)
	}

	return (
		<div className="submodule">
			<div className="sub-header">
				<ContextualHeader
					breadcrumbs={createBreadcrumbsTranslated(intl, BREADCRUMB_OPTIONS)}
				/>
			</div>
			<h1 className="header">
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.title",
				})}
			</h1>
			<div className="description">
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.description",
				})}
			</div>
			<Card className="card">{getComponent()}</Card>
		</div>
	)
}

export default ChangePw
